export const Layer = "CreateCharacter";
